import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux';
import { FormattedMessage } from 'react-intl';

import HtmlPage from 'views/htmlPage/HtmlPage';
import SplitPane from 'views/splitPane/SplitPane';
import UsersForm from 'views/usersForm/UsersForm';
import UsersList from 'views/usersList/UsersList';
import Button from 'views/button/Button';


import './users.scss';
import URLService from "../../../service/URLService";

import usersStore from 'storeState/users';
import tenantsStore from 'storeState/tenants';
import authStore from 'storeState/auth';
import _ from 'lodash';

class Users extends Component {

    constructor(props) {
        super(props);
    }

    onUserSelect = (user_id) => {
        URLService.setQueryParameter("user_id", user_id);
        this.setState({})
    }

    handleNewClick = (user_id) => {
        URLService.removeQueryParameter("user_id");
        this.setState({})
    }

    componentsWillReceiveProps = (nextProps) => {
        let user_id = URLService.getQueryParameterAsString("user_id")
        if(user_id && !_.find(nextProps,(u) => u.id == user_id)) {
            URLService.removeQueryParameter("user_id");
        }
    }

    render() {
        return (
            <HtmlPage className="screen-users" >
                <div className="content-users">
                    <If condition={this.props.loginData.tenant_role=="admin"}>
                        <SplitPane percentage={true} id="users" store={true}>
                            <div>
                                <div className="users-buttonbar">
                                    <Button onClick={this.handleNewClick}>
                                        <FormattedMessage id="users.create" defaultMessage="Create a new user"  />
                                    </Button>
                                </div>
                                <UsersList
                                    onUserSelect={this.onUserSelect}
                                    tenant_id={this.props.currentTenantId}
                                />
                            </div>
                            <UsersForm
                                user_id={URLService.getQueryParameterAsString("user_id")}
                                tenant_id={this.props.currentTenantId}
                            />
                        </SplitPane>
                    <Else />
                        <div className="ownprofile-wrapper">
                            <UsersForm
                                user_id={URLService.getQueryParameterAsString("user_id")}
                                tenant_id={this.props.currentTenantId}
                            />
                        </div>
                    </If>
                </div>
            </HtmlPage>
        );
    }
}

export default connect((state, props) => {
    return {
        users: usersStore.selectors.usersList(state),
        loginData: authStore.selectors.loginData(state),
        currentTenantId: authStore.selectors.currentTenantId(state)
    }
},(dispatch, props) => {
    return {
        actions: bindActionCreators(Object.assign({}, {...tenantsStore.actions, ...usersStore.actions}), dispatch)
    }
})(Users)


// WEBPACK FOOTER //
// ./src/components/screens/users/Users.js